import {DynamicDatagrid, MuiDataGrid, Paper} from "@leap4/frontend";
import * as React from "react";
import {ITopTagCombo} from "@leap4/entities-discrepancy-common";
import {EntitiesProperties} from "../../../../../utils/enums";
import {useContext, useEffect, useState} from "react";
import {UserViewsContext} from "../../../../../contexts/userViewsContext";
import {generateColumn} from "../../../common/tableColumnsGenerator";
import * as _ from 'lodash'
type GridColDef = MuiDataGrid.GridColDef;
export interface IHomeTagsTableProps {
    tags: Array<ITopTagCombo>,
    isLoading: boolean
    compareData: Array<ITopTagCombo>
    refreshFunc?: () => void;
}

export default function HomeTopTagsTable(props: IHomeTagsTableProps): JSX.Element {
    const {tags, isLoading, compareData} = props;
    const {userViews} = useContext(UserViewsContext)
    const [columns, setColumns] = useState<GridColDef[]>([])

    const {
        DEMAND_TAG,
        SUPPLY_TAG,
        DATAPOINT,
        ADSERVER
    } = EntitiesProperties.NOT_NUMERIC

    useEffect(()=>{
        const userPresetColumns = userViews.activePreset.tableViews.map(view => generateColumn(view, compareData))
        const preConstantColumns = [SUPPLY_TAG, DEMAND_TAG].map(view => generateColumn(view, compareData))
        const postConstantColumns = [DATAPOINT, ADSERVER].map(view => generateColumn(view, compareData))
        setColumns([...preConstantColumns,...userPresetColumns, ...postConstantColumns])
    },[userViews, compareData])
    function refreshTable(): void {
        if (props.refreshFunc) {
            props.refreshFunc();
        } else {
            alert("No refresh function provided");
        }
    }

    function createRowData(item: ITopTagCombo) {
        const {totals} = item;
        const profit = totals?.revenue - totals?.cost;
        if (!item.demandTag || !item.supplyTag || _.isEmpty(item.demandTag) || _.isEmpty(item.supplyTag)) {
            return null
        }
        return {
            id: item.demandTag._id.toString() + item.supplyTag._id.toString(),
            adServer: item.adServer.name,
            dataPoint: item.dataPoint.name,
            supplyTag: item.supplyTag.name,
            demandTag: item.demandTag.name,
            completion: totals?.completion || 0,
            profit: profit,
            profitPercent: (profit / totals?.revenue) * 100,
            fillRate: ((totals?.impressions || 0) / (totals?.requests)) * 100,
            cpm: totals?.impressions === 0 ? 0 : totals?.cost / totals?.impressions * 1000,
            rpm: totals?.impressions === 0 ? 0 : totals?.revenue / totals?.impressions * 1000,
            vcr: totals?.impressions === 0 ? 0 : totals?.completion / totals?.impressions * 100,
            netProfit: totals?.netRevenue - totals?.netCost,
            ...totals,
        }
    }
    const rows = tags.map((tag,) =>
        createRowData(tag)
    ).filter(x => !!x).sort((a, b) => b.impressions > a.impressions ? 1 : -1);

    return (
        <Paper sx={{margin: "20px 0", borderRadius: "16px", boxShadow: 'none'}} elevation={5}>
            <DynamicDatagrid rows={rows}
                             columns={columns}
                             loading={isLoading}
                             refreshFunc={() => {refreshTable()
                             }}
                             loadError={false}
                             pageSize={25}
                             style={{minHeight: `75vh`, width: '100%'}}
            />
        </Paper>
    );
}
